import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Skeleton } from "@mui/material";
import PaperDraggable from "../../../PaperDraggable";

interface DialogCartaoSkeletonProps {
    open: boolean;
}

export default function DialogCartaoSkeleton({ open }: DialogCartaoSkeletonProps) {
    return (
        <Dialog
            open={open}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth={"xs"}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                <Skeleton variant="text" width={80} height={28} />
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mt={1}>
                    <Grid size={{ xs: 12 }}>
                        <Skeleton variant="rectangular" height={56} />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Skeleton variant="rectangular" height={56} />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Skeleton variant="rectangular" height={56} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
                <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1, ml: 1 }} />
            </DialogActions>
        </Dialog>
    );
}